// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_DELEGATE_FIELD,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { getResourceIdXML } from "helpers/form_helper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlRegistryDelegate,
  getListRegistryDelegate,
  releaseRegistryDelegate,
  resetCreateRegistryDelegate,
  resetDownloadXmlRegistryDelegate,
  resetEditRegistryDelegate,
  resetListRegistryDelegate,
  resetReleaseRegistryDelegate,
  setColumnVisibleRegistryDelegate,
} from "store/actions";
import {
  CREATE_REGISTRY_DELEGATE_FAIL,
  CREATE_REGISTRY_DELEGATE_SUCCESS,
  DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL,
  DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS,
  EDIT_REGISTRY_DELEGATE_FAIL,
  EDIT_REGISTRY_DELEGATE_SUCCESS,
} from "store/data-format/actionTypes";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getRegistryStatus } from "../helper/functionHelper";
import ErrorReleaseModal from "../modal/ErrorReleaseModal";
import SignHSMModal from "../modal/SignHSMModal";
import TypeSignDigitalModal from "../modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "../modal/VerifyPinUSBModal";
import { MODE_FORM, tableFormateDate } from "../utils";
import DetailData from "./DetailData";

const ListData = props => {
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalErrorRelease
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // Release modal
  const [idRelease, setIdRelease] = useState(null);
  const [modalRelease, setModalRelease] = useState(false);
  const toggleReleaseModal = () => setModalRelease(!modalRelease);

  const toggleViewDetailModal = () => setModalDetail(!modalDetail);
  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const dataFormat = useSelector(state => state.dataFormat);
  const { fileDownload, fileDownloadName, type } = dataFormat;
  const { loading, listData, totalCount, columnsVisible, params } =
    dataFormat.registryDelegate;

  const { t, i18n } = useTranslation(["registryDelegate"]);

  const [commonStatus, setCommonStatus] = useState(getRegistryStatus(t));

  useEffect(() => {
    setCommonStatus(getRegistryStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case CREATE_REGISTRY_DELEGATE_SUCCESS:
        addToast(t("form.submit.create.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListRegistryDelegate(params));
        dispatch(resetCreateRegistryDelegate());
        break;
      case CREATE_REGISTRY_DELEGATE_FAIL:
        addToast(t("form.submit.create.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateRegistryDelegate());
        break;

      case EDIT_REGISTRY_DELEGATE_SUCCESS:
        addToast(t("form.submit.edit.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListRegistryDelegate(params));
        dispatch(resetEditRegistryDelegate());
        break;
      case EDIT_REGISTRY_DELEGATE_FAIL:
        addToast(t("form.submit.edit.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetEditRegistryDelegate());
        break;
      case DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlRegistryDelegate());
        break;
      }
      case DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL:
        if (!modalUSBSign) {
          console.log('vvvvvvv');
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlRegistryDelegate());
        break;
      default:
        break;
    }
  }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (tenantCodeHeader) {
      params.page = 1;
      dispatch(getListRegistryDelegate(params));
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetListRegistryDelegate());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: t("action.edit"),
      conditionVisible: {
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setDataDetail({ id: row.id, mode: MODE_FORM.EDIT });
        setIdRelease(row.id);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type);
        if (resource_id) {
          dispatch(
            downloadXmlRegistryDelegate(
              resource_id,
              row[REGISTRY_DELEGATE_FIELD.COMMON.TEN.field]
            )
          );
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành tờ khai",
      conditionVisible: {
        resource_id: [],
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setTransferData({
          id: row.id,
          mst: row.mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.REGISTER,
        });
        toggleTypeSignModal();
      },
    },
  ];

  const OPTION_DELEGATE = [
    {
      value: REGISTRY_DELEGATE_FIELD.COMMON.LDKUNHIEM.selectValues.DELEGATE,
      label: t("select.delegate"),
    },
    {
      value: REGISTRY_DELEGATE_FIELD.COMMON.LDKUNHIEM.selectValues.GET_MANDATE,
      label: t("select.getMandate"),
    },
  ];

  const selectFilterLdkunhiem = {
    [REGISTRY_DELEGATE_FIELD.COMMON.LDKUNHIEM.selectValues.DELEGATE]:
      t("select.delegate"),
    [REGISTRY_DELEGATE_FIELD.COMMON.LDKUNHIEM.selectValues.GET_MANDATE]:
      t("select.getMandate"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "pban",
      text: t("field.pban"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ten",
      text: t("field.ten"),
      hidden: false,
      formatter: (cellContent, row) => (
        <div style={{ width: "200px", whiteSpace: "initial" }}>{row.ten}</div>
      ),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "mso",
      text: t("field.mso"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ldkunhiem",
      text: t("field.ldkunhiem"),
      hidden: false,
      formatter: (cellContent, row) => {
        const value = OPTION_DELEGATE.find(
          item => Number(item.value) === Number(row.ldkunhiem)
        );
        return value ? value.label : "";
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterLdkunhiem,
      }),
    },
    {
      dataField: "tnnt",
      text: t("field.tnnt"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "mst",
      text: t("field.mst"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "cqtqly",
      text: t("field.cqtqly"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "mcqtqly",
      text: t("field.mcqtqly"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "nlhe",
      text: t("field.nlhe"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dclhe",
      text: t("field.dclhe"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dctdtu",
      text: t("field.dctdtu"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dtlhe",
      text: t("field.dtlhe"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ddanh",
      text: t("field.ddanh"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "nlap",
      text: t("field.nlap"),
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.nlap),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_date",
      text: t("field.maker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.maker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "maker.display_name",
      text: t("field.maker_id"),
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
    {
      dataField: "checker_date",
      text: t("field.checker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "checker.display_name",
      text: t("field.checker_id"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
    {
      dataField: "resource_id",
      text: "resource_id",
      sort: true,
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListRegistryDelegate(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListRegistryDelegate(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleRegistryDelegate(field, value));
  };

  return (
    <React.Fragment>
      <DetailData
        dataDetail={dataDetail}
        isOpen={modalDetail}
        t={t}
        i18n={i18n}
        toggle={toggleViewDetailModal}
        toggleReleaseModal={toggleReleaseModal}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"registry-delegates"}
      />
      {/* Hình thức ký modal */}
      <TypeSignDigitalModal
        isOpen={modalTypeSign}
        t={t}
        downloadXmlFunc={downloadXmlRegistryDelegate}
        transferData={transferData}
        toggle={toggleTypeSignModal}
        toggleUSBSignModal={toggleUSBSignModal}
        toggleHSMSignModal={toggleHSMSignModal}
      />
      {/* Ký USB Modal */}
      <VerifyPinUSBModal
        t={t}
        isOpen={modalUSBSign}
        transferData={transferData}
        resetDataFunc={getListRegistryDelegate}
        params={params}
        toggle={toggleUSBSignModal}
      />
      {/* Ký HSM Modal */}
      <SignHSMModal
        t={t}
        isOpen={modalHSMSign}
        transferData={transferData}
        resetDataFunc={getListRegistryDelegate}
        releaseFunc={releaseRegistryDelegate}
        resetReleaseFunc={resetReleaseRegistryDelegate}
        params={params}
        toggle={toggleHSMSignModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>{t("title.registryDelegate")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={t("title.registryDelegate") + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          setDataDetail({ mode: MODE_FORM.ADD });
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        {t("button.add")}
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
